/**
 * SignInPrompt - Shown when there is no authenticated user
 */

interface SignInPromptProps {
  onLogin: () => void;
  onGuestSignIn: () => void;
}

export function SignInPrompt({ onLogin, onGuestSignIn }: SignInPromptProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-canvas">
      <div className="text-center max-w-md px-6">
        <h2 className="font-sans text-2xl font-semibold tracking-tight text-ink mb-4">Inicia sesión</h2>
        <p className="text-sm text-ink-muted mb-6">Debes iniciar sesión para sacar turno</p>

        <div className="space-y-3">
          <button
            onClick={onLogin}
            className="w-full bg-accent text-on-accent px-6 py-3 rounded-lg hover:bg-accent-hover transition-colors font-semibold focus:outline-none focus:ring-2 focus:ring-focus"
          >
            Iniciar Sesión
          </button>

          <button
            onClick={onGuestSignIn}
            className="w-full bg-surface-2 border border-hairline text-ink px-6 py-3 rounded-lg hover:bg-surface-3 transition-colors font-semibold"
          >
            Continuar como Invitado
          </button>
        </div>

        <p className="text-sm text-ink-muted mt-4">
          Como invitado podrás sacar turno sin crear una cuenta. Podrás vincular tu cuenta después si lo deseas.
        </p>
      </div>
    </div>
  );
}
